// extracted by mini-css-extract-plugin
export var gaugeBackground = "_011-radial-gauge-module--gauge-background--2BxLL";
export var gaugeSize = "_011-radial-gauge-module--gauge-size--19keD";